var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 83,
    viewBox: "0 0 82 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.19922L81 2.19922",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8994L81 11.8994",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5996L81 21.5996",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.2998L81 31.2998",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 41L81 41",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50.7002L81 50.7002",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 60.4004L81 60.4004",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 70.1006L81 70.1006",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 79.8008L81 79.8008",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 81L2.19922 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8984 81L11.8984 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 81L21.6016 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3008 81L31.3008 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81L41 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6992 81L50.6992 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3984 81L60.3984 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1016 81L70.1016 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8008 81L79.8008 0.999997",
    stroke: "#E0E1DC",
    strokeWidth: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.1992V2.19922C1 1.64693 1.44772 1.19922 2 1.19922H21",
    stroke: "#CCCDC8",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21 81.1992H2C1.44772 81.1992 1 80.7515 1 80.1992L1 61.1992",
    stroke: "#CCCDC8",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1.19922L80 1.19922C80.5523 1.19922 81 1.64693 81 2.19922V21.1992",
    stroke: "#CCCDC8",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61.1992V80.1992C81 80.7515 80.5523 81.1992 80 81.1992H61",
    stroke: "#CCCDC8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBox);
export default __webpack_public_path__ + "static/media/SquareBox.8ebf6e4cf8188c3f1ef8fc23e15ae622.svg";
export { ForwardRef as ReactComponent };